<script>
	import {
		Dropdown,
		DropdownToggle,
		DropdownMenu,
		DropdownItem,
	} from "@sveltestrap/sveltestrap";
	import { statusBadgeStyle } from "src/utils/statusBadge";

	export let row = {};
	export let key = "";
	export let options = {};
	export let transitionsKey = "allowedTransitions";
	export let event = undefined;

	$: value = row[key] || "";
	$: transitionOptions = row[transitionsKey] || [];

	function handleSelect(option) {
		if (event) {
			event(row, option);
		}
	}
</script>

{#if transitionOptions.length > 0}
	<Dropdown>
		<DropdownToggle
			tag="button"
			type="button"
			class="status-dropdown-toggle"
		>
			<span
				class="status-badge"
				style={statusBadgeStyle(options?.[value])}
			>
				{value.toUpperCase()}
			</span>
			<img
				src="/assets/icon-chevron-down.png"
				alt=""
				class="chevron-icon"
			/>
		</DropdownToggle>
		<DropdownMenu class="status-dropdown-menu">
			{#each transitionOptions as option}
				<DropdownItem on:click={() => handleSelect(option)}>
					<span
						class="status-badge"
						style={statusBadgeStyle(options?.[option])}
					>
						{option.toUpperCase()}
					</span>
				</DropdownItem>
			{/each}
		</DropdownMenu>
	</Dropdown>
{:else}
	<span class="status-badge" style={statusBadgeStyle(options?.[value])}>
		{value.toUpperCase()}
	</span>
{/if}

<style>
	/* sveltestrap's DropdownToggle only skips its `btn btn-secondary` classes
	   for tag="div"/"span"/nav — tag="button" still gets them stacked on top
	   of this class, at equal specificity, so `!important` is needed to
	   actually win over Bootstrap's button background/border here. */
	:global(button.status-dropdown-toggle) {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		width: 100%;
		background: none !important;
		border: none !important;
		box-shadow: none !important;
		padding: 0;
		font: inherit;
		text-align: inherit;
		cursor: pointer;
	}

	:global(.dropdown-menu.status-dropdown-menu) {
		padding: 0;
		overflow: hidden;
		border: 1px solid var(--fds-outline, #adaeb2);
		border-radius: 8px;
		box-shadow: none;
	}

	:global(.status-dropdown-menu .dropdown-item) {
		display: flex;
		align-items: center;
		height: 48px;
		padding: 12px 16px;
	}

	:global(.status-dropdown-menu .dropdown-item:hover),
	:global(.status-dropdown-menu .dropdown-item:focus),
	:global(.status-dropdown-menu .dropdown-item:active) {
		background-color: #f1f1f1;
		color: inherit;
	}

	:global(.status-dropdown-menu) .status-badge {
		line-height: 16px;
	}

	.status-badge {
		display: inline-block;
		border-radius: 4px;
		padding: 4px 8px;
		font-size: 12px;
		font-weight: bold;
		white-space: nowrap;
	}

	.chevron-icon {
		width: 24px;
		height: 24px;
	}
</style>
